import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import ContentAdd from '@material-ui/icons/Add'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import BarCardComponent from './BarCardComponent'
import Grid from '@material-ui/core/Grid'
const styles = theme => ({
  progress: {
    position: 'absolute',
    top: -3,
    left: -3,
    zIndex: 1
  },
  barButton: {
    marginLeft: 15,
    marginTop: 15
  },
  addButton: {
    position: 'absolute',
    bottom: 15,
    left: 15
  },
  container: {
    position: 'relative',
    padding: 10,
    height: 'calc(100%)'
  }
})
export default withStyles(styles)(
  class BarsComponent extends Component {
    static propTypes = {
      classes: PropTypes.object.isRequired,
      bars: PropTypes.array.isRequired,
      createBar: PropTypes.func.isRequired
    }
    state = {
      loading: false
    }
    componentWillReceiveProps(nextProps) {
      if (
        nextProps.bars.length > 0 &&
        nextProps.bars[nextProps.bars.length - 1].currentTransaction
      ) {
        this.setState({ loading: false })
      }
    }
    handleAddBar = e => {
      this.props.createBar()
      this.setState({ loading: true })
    }
    render() {
      const { classes, bars } = this.props
      return (
        <div className={classes.container}>
          <Grid
            item
            container
            direction="row"
            alignItems="flex-start"
            justify="flex-start"
            spacing={16}>
            {bars.map((bar, index) => (
              <BarCardComponent key={bar.key} bar={bar} />
            ))}
          </Grid>
          <Button
            className={classes.addButton}
            variant="fab"
            disabled={this.state.loading}
            color="secondary"
            onClick={this.handleAddBar}>
            <ContentAdd color="inherit" />
            {this.state.loading && (
              <CircularProgress
                color="secondary"
                size={62}
                thickness={3}
                className={classes.progress}
              />
            )}
          </Button>
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Home/components/bar/BarsComponent.js